<template>
  <div :class="classes" @click="$_onItemClick">
    <div v-if="!isLast" :class="`${prefixStepsClass}-tail`"><i></i></div>
    <div :class="`${prefixStepsClass}-step`">
      <div :class="`${prefixStepsClass}-head`">
        <div :class="`${prefixStepsClass}-head__inner`">
          <span v-if="icon || status === 'finish' || status === 'error'" :class="iconClass">
          </span>
          <span v-else :class="`${prefixStepsClass}-icon`">
            {{ stepNumber }}
          </span>
        </div>
      </div>
      <div :class="`${prefixStepsClass}-main`">
        <div :class="`${prefixStepsClass}-main__title`">{{ title }}</div>
        <div v-if="desc" :class="`${prefixStepsClass}-main__description`">{{ desc }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { PREFIX_CLASS, PREFIX_ICON_CLASS, CLASS_MAIN } from '../../utils/constants'

const PREFIX_STEPS_CLASS = `${PREFIX_CLASS}steps`

export default {
  props: {
    icon: String,
    title: String,
    desc: String,
    name: {
      type: [String, Number]
    }
  },
  data() {
    return {
      stepNumber: '',
      nextError: false,
      status: '',
      isLast: false,
      prefixStepsClass: PREFIX_STEPS_CLASS
    }
  },
  computed: {
    classes() {
      return [
        `${PREFIX_STEPS_CLASS}-item`,
        `${PREFIX_STEPS_CLASS}-item--status-${this.status}`,
        {
          [`${PREFIX_STEPS_CLASS}-custom`]: !!this.icon,
          [`${PREFIX_STEPS_CLASS}-next-error`]: this.nextError
        }
      ]
    },
    iconClass() {
      return {
        [`${PREFIX_STEPS_CLASS}-icon`]: true,
        [`${CLASS_MAIN}`]: true,
        [`${PREFIX_ICON_CLASS}${this.icon}`]: this.icon,
        [`${PREFIX_ICON_CLASS}check`]:
          this.status === 'finish' || this.icon === 'check',
        [`${PREFIX_ICON_CLASS}close`]:
          this.status === 'error' || this.icon === 'close'
      }
    }
  },
  mounted() {
    this.$parent.$emit('step-mounted', this)
  },
  destroyed() {
    this.$parent.$emit('step-destroyed')
  },
  methods: {
    $_onItemClick(event) {
      const $parent = this.$parent
      this.$emit('on-click', this.name, event)
      $parent.$emit('on-item-click', this.name, event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// step.vue?21b18816